module.exports = __webpack_public_path__ + "static/media/gcash.899b8154.png";